/* eslint-disable */
import _m0 from "protobufjs/minimal";
import { TriggerArgs_TimerCallback } from "../../trigger_args";

export const protobufPackage = "complimentary_actions";

export interface SimEventPacketlossActionArgs {
  trigger:
    | TriggerArgs_TimerCallback
    | undefined;
  /** How long the packet loss should last. Infinite if <= 0. Seconds. */
  duration: number;
  /** The packet drop rate to set for all traffic to destination port UDP 443 */
  dropRateDestinationPortUdp443: number;
}

function createBaseSimEventPacketlossActionArgs(): SimEventPacketlossActionArgs {
  return { trigger: undefined, duration: 0, dropRateDestinationPortUdp443: 0 };
}

export const SimEventPacketlossActionArgs = {
  encode(message: SimEventPacketlossActionArgs, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.trigger !== undefined) {
      TriggerArgs_TimerCallback.encode(message.trigger, writer.uint32(10).fork()).ldelim();
    }
    if (message.duration !== 0) {
      writer.uint32(21).float(message.duration);
    }
    if (message.dropRateDestinationPortUdp443 !== 0) {
      writer.uint32(29).float(message.dropRateDestinationPortUdp443);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): SimEventPacketlossActionArgs {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSimEventPacketlossActionArgs();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.trigger = TriggerArgs_TimerCallback.decode(reader, reader.uint32());
          continue;
        case 2:
          if (tag !== 21) {
            break;
          }

          message.duration = reader.float();
          continue;
        case 3:
          if (tag !== 29) {
            break;
          }

          message.dropRateDestinationPortUdp443 = reader.float();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SimEventPacketlossActionArgs {
    return {
      trigger: isSet(object.trigger) ? TriggerArgs_TimerCallback.fromJSON(object.trigger) : undefined,
      duration: isSet(object.duration) ? globalThis.Number(object.duration) : 0,
      dropRateDestinationPortUdp443: isSet(object.dropRateDestinationPortUdp443)
        ? globalThis.Number(object.dropRateDestinationPortUdp443)
        : 0,
    };
  },

  toJSON(message: SimEventPacketlossActionArgs): unknown {
    const obj: any = {};
    if (message.trigger !== undefined) {
      obj.trigger = TriggerArgs_TimerCallback.toJSON(message.trigger);
    }
    if (message.duration !== 0) {
      obj.duration = message.duration;
    }
    if (message.dropRateDestinationPortUdp443 !== 0) {
      obj.dropRateDestinationPortUdp443 = message.dropRateDestinationPortUdp443;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SimEventPacketlossActionArgs>, I>>(base?: I): SimEventPacketlossActionArgs {
    return SimEventPacketlossActionArgs.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SimEventPacketlossActionArgs>, I>>(object: I): SimEventPacketlossActionArgs {
    const message = createBaseSimEventPacketlossActionArgs();
    message.trigger = (object.trigger !== undefined && object.trigger !== null)
      ? TriggerArgs_TimerCallback.fromPartial(object.trigger)
      : undefined;
    message.duration = object.duration ?? 0;
    message.dropRateDestinationPortUdp443 = object.dropRateDestinationPortUdp443 ?? 0;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
